/**
 * Multinational Comics — Phase 2.5 chrome JS (isolated)
 * Disables Venture sticky clone; compresses the same chrome object on scroll.
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function afterThemeSections(fn) {
    ready(function () {
      /* HeaderSection inits on DOMContentLoaded before later listeners if registered first.
         Defer one frame (+ timeout) so we can unload sticky after Venture init. */
      window.requestAnimationFrame(function () {
        window.setTimeout(fn, 0);
      });
    });
  }

  function updateCartBadges(count) {
    var n = parseInt(count, 10);
    if (isNaN(n)) return;

    document.querySelectorAll('[data-mc-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) {
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });

    document.querySelectorAll('[data-mc-cart-link]').forEach(function (link) {
      var hidden = link.querySelector('.visually-hidden');
      if (!hidden) return;
      var base = (hidden.getAttribute('data-mc-cart-label') || 'Cart').trim();
      if (!hidden.getAttribute('data-mc-cart-label')) {
        var cleaned = hidden.textContent.replace(/,\s*\d+\s*$/, '').trim();
        if (cleaned) {
          hidden.setAttribute('data-mc-cart-label', cleaned);
          base = cleaned;
        }
      }
      hidden.textContent = n > 0 ? base + ', ' + n : base;
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') {
          updateCartBadges(cart.item_count);
        }
      })
      .catch(function () {});
  }

  function disableVentureSticky() {
    if (window.theme && theme.stickyHeader && typeof theme.stickyHeader.unload === 'function') {
      theme.stickyHeader.unload();
    }

    var slot = document.getElementById('StickyNavSearchCart');
    if (slot) {
      slot.innerHTML = '';
      slot.setAttribute('hidden', 'hidden');
      slot.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('#StickyBar.sticky--active, #StickyBar.sticky--open').forEach(function (el) {
      el.classList.remove('sticky--active', 'sticky--open', 'sticky--close');
    });
  }

  function initChromeSticky() {
    var header = document.querySelector('[data-mc-header]');
    var shell = document.querySelector('[data-mc-chrome-sticky]');
    if (!header || !shell) return;

    var threshold = 12;
    var ticking = false;

    function update() {
      var compact = window.scrollY > threshold;
      header.classList.toggle('mc-header--compact', compact);
      shell.classList.toggle('mc-chrome-sticky--compact', compact);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function initHeaderSearch() {
    var roots = document.querySelectorAll('[data-mc-header-search]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.getAttribute('data-mc-search-ready') === 'true') return;

      var trigger = root.querySelector('[data-mc-search-trigger]');
      var form = root.querySelector('[data-mc-search-form]');
      var input = form && form.querySelector('input[type="search"]');
      var closeBtn = root.querySelector('[data-mc-search-close]');
      if (!trigger || !form || !input) return;

      root.setAttribute('data-mc-search-ready', 'true');

      function isOpen() {
        return root.classList.contains('is-open');
      }

      function openSearch() {
        root.classList.add('is-open');
        form.removeAttribute('hidden');
        form.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        window.setTimeout(function () {
          try {
            input.focus({ preventScroll: true });
          } catch (e) {
            input.focus();
          }
          if (typeof input.select === 'function' && input.value) {
            input.select();
          }
        }, 10);
      }

      function closeSearch(returnFocus) {
        root.classList.remove('is-open');
        form.setAttribute('hidden', 'hidden');
        form.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus !== false) {
          trigger.focus();
        }
      }

      trigger.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (isOpen()) {
          closeSearch(false);
        } else {
          openSearch();
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          closeSearch(true);
        });
      }

      form.addEventListener('submit', function (evt) {
        var q = (input.value || '').trim();
        if (!q) {
          evt.preventDefault();
          return;
        }
        input.value = q;
      });

      document.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Escape') return;
        if (!isOpen()) return;
        evt.preventDefault();
        closeSearch(true);
      });

      document.addEventListener(
        'pointerdown',
        function (evt) {
          if (!isOpen()) return;
          if (root.contains(evt.target)) return;
          closeSearch(false);
        },
        true
      );
    });
  }

  function initDrawerCloseHooks() {
    var drawer = document.querySelector('[data-mc-drawer]');
    if (!drawer) return;

    var openers = document.querySelectorAll('.js-drawer-open-left');
    var lastOpener = null;

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        lastOpener = btn;
      });
    });

    var observer = new MutationObserver(function () {
      var open = document.body.classList.contains('js-drawer-open');
      openers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (!open && lastOpener) {
        var active = document.activeElement;
        var inDrawer = active && active.closest && active.closest('#NavDrawer');
        if (!active || active === document.body || inDrawer) {
          lastOpener.focus();
        }
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function initCartCountSync() {
    var success = document.getElementById('NotificationSuccess');
    if (success) {
      var observer = new MutationObserver(function () {
        if (success.getAttribute('aria-hidden') === 'false') {
          refreshCartCount();
        }
      });
      observer.observe(success, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    document.addEventListener(
      'submit',
      function (evt) {
        var form = evt.target;
        if (!form || !form.matches) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') !== -1 || (form.classList && form.classList.contains('product-form'))) {
          window.setTimeout(refreshCartCount, 700);
        }
      },
      true
    );

    if (window.jQuery) {
      window.jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        var url = (settings && settings.url) || '';
        if (!/\/cart\/(add|change|update|clear)/.test(url)) return;
        try {
          var data = JSON.parse(xhr.responseText);
          if (data && typeof data.item_count !== 'undefined') {
            updateCartBadges(data.item_count);
            return;
          }
        } catch (e) {}
        refreshCartCount();
      });
    }

    refreshCartCount();
  }

  function initAnnouncementFocus() {
    var closeBtn = document.getElementById('NotificationPromoClose');
    if (!closeBtn) return;
    closeBtn.addEventListener('click', function () {
      var skip = document.querySelector('.skip-link');
      if (skip) skip.focus();
    });
  }

  afterThemeSections(function () {
    disableVentureSticky();
    initChromeSticky();
    initHeaderSearch();
    initDrawerCloseHooks();
    initCartCountSync();
    initAnnouncementFocus();

    if (REDUCE.matches) {
      document.documentElement.classList.add('mc-reduce-motion');
    }

    /* Re-assert if Theme Editor reinits the section */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-mc-header-search]').forEach(function (el) {
        el.removeAttribute('data-mc-search-ready');
      });
      disableVentureSticky();
      initChromeSticky();
      initHeaderSearch();
    });
  });

  /* Ensure search works even if later chrome init fails */
  ready(function () {
    initHeaderSearch();
  });
})();
